import module from './module.js'
// Services
import './services/Catalogo/ActividadEconomica.js'
import './services/Catalogo/Bancos.js'
import './services/Catalogo/ClientesDocumentos.js'
import './services/Catalogo/DiasVacaciones.js'
import './services/Catalogo/EjerciciosFiscales.js'
import './services/Catalogo/Empresas.js'
import './services/Catalogo/EmpresasCuentas.js'
import './services/Catalogo/EntidadesFederativas.js'
import './services/Catalogo/EstadoCivil.js'
import './services/Catalogo/Estados.js'
import './services/Catalogo/EstadosSat.js'
import './services/Catalogo/FiniquitoConceptos.js'
import './services/Catalogo/Firmantes.js'
import './services/Catalogo/GiroMercantil.js'
import './services/Catalogo/Impuestos.js'
import './services/Catalogo/ImssImpuestos.js'
import './services/Catalogo/MetodosCalculoComision.js'
import './services/Catalogo/MetodosCalculoSuministro.js'
import './services/Catalogo/Monedas.js'
import './services/Catalogo/Nacionalidad.js'
import './services/Catalogo/RegimenesFiscales.js'
import './services/Catalogo/RepresentanteTipo.js'
import './services/Catalogo/SatMetodosPago.js'
import './services/Catalogo/Subsidios.js'
import './services/Catalogo/Sucursales.js'
import './services/Catalogo/TiposComision.js'

export default module.name



// WEBPACK FOOTER //
// ./src/catalogo/index.js